import React from 'react';

import { Popover } from 'common/ui/themes/disona/floating/Popover';

export const AccountTypeSwitch = ({ options, onChange, value, shadow }) => (
  <Popover
    options={options}
    onChange={onChange}
    value={value}
    shadow={shadow}
    label="Accounts:"
  />
);
